import { render, staticRenderFns } from "./ReportHuaningOweFeeDetail.vue?vue&type=template&id=193ae86a&scoped=true"
import script from "./ReportHuaningOweFeeDetail.vue?vue&type=script&lang=js"
export * from "./ReportHuaningOweFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportHuaningOweFeeDetail.vue?vue&type=style&index=0&id=193ae86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ae86a",
  null
  
)

export default component.exports